import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Highlight from "../Highlight/Highlight";
import { Images } from "../../assets";

const Carousel = () => {
  // Data for the items
  const items = [
    {
      src: Images.PIZZA_ICON,
      alt: "Icône de pizza",
      text: "Authentiques, savoureuses, aux saveurs italiennes incomparables",
      to: "Pizza",
    },
    {
      src: Images.DRINK_ICON,
      alt: "Icône de verre de vin",
      text: "Vins fins et cocktails pour sublimer chaque bouchée",
      to: "Bevande E Caffè",
    },
    {
      src: Images.ICE_CREAM_ICON,
      alt: "Icône de glace",
      text: "Douceur italienne : tiramisus, glaces crémeuses et plus",
      to: "Dolci",
    },
  ];

  // Slider settings for mobile
  const mobileSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <>
      {/* Mobile layout using Slider to display items */}
      <div className="block md:hidden w-full overflow-hidden mb-8">
        <Slider {...mobileSettings}>
          {items.map((item, index) => (
            <Highlight key={index} {...item} />
          ))}
        </Slider>
      </div>

      {/* Desktop layout using flex for even spacing */}
      <div className="hidden md:flex justify-around gap-5 w-full mb-[3em]">
        {items.map((item, index) => (
          <Highlight key={index} {...item} />
        ))}
      </div>
    </>
  );
};

export default Carousel;
